import { DropDown, SearchBar, NewSiteButton } from "../components/textField";
import TopNav from "../components/topnav";
import { useEffect, useState, useMemo } from "react";
import UploadModal from "../components/uploadModal";
import { content } from "../utils/data";
import EnhancedTable from "../components/newTable";
import Edit from "../assests/edit.png";
import {
  getDocumentClassificationDropDown,
  getPropertyTaxApplicability,
  getStatesDropDown,
  getLocationDropDown,
  getSiteDropDown,
  getDocumentCatgory,
  getDocumentCategoriesByAccess,
  getUniqueNo,
  getDocumentType,
  getDocumentUploaded,
  formUpload,
  getOsNumber,
  getEntity,
  getBuildingCode,
  reupload,
  getUploadPermissionDocumentCategory,
  getStatesUploadPermissionDropDown,
  getLocationUploadPermissionDropDown,
  getSiteUploadPermissionDropDown,
  reportLog,
  getUploadAllDocumentCategory,
  getAllDocumentType,
    getCnrNumber, // ADD
} from "../api/serverApi";
import DocumentModal from "../components/documentModal";
import { Button, Grid, Box } from "@mui/material";
import EditUpload from "../components/editUpload";
import { useCookies } from "react-cookie";
import Spinner from "../components/spinner";
import StatusModal from "../components/statusModal";
import { useMsal } from "@azure/msal-react";
import { getValidAccessToken } from "../services/garphService";
import * as microsoftTeams from "@microsoft/teams-js";

const Upload = () => {
  const [open, setOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [documentClassification, setDocumentClassification] = useState([]);
  const [selectedDocumentClassification, setSelectedDocumentClassification] =
    useState("");

  const [getState, setGetState] = useState([]);
  const [getLocation, setGetLocation] = useState([]);
  const [getSite, setGetSite] = useState([]);
  const [selectedStateId, setSelectedStateId] = useState("");
  const [selectedLocationId, setSelectedLocationId] = useState("");
  const [selectedSiteId, setSelecteSiteId] = useState(0);
  const [documentCategory, setDocumentCategory] = useState([]);

  const [documentType, setDocumentType] = useState([]);
  const [selectedDocumentCategory, setSelectedDocumentCategory] = useState("");
  const [propertyTaxData, setPropertyTaxData] = useState([]);
  const [propertyTax, setPropertyTax] = useState("");
  const [selectedDocumentType, setSelectedDocumentType] = useState(0);
  const [uniqueNo, setUniqueNo] = useState([]);
  const [selectedUnique, setSelectedUnique] = useState([]);
  const [responseData, setResponseData] = useState([]);
  const [box, setBox] = useState("");
  const [date, setDate] = useState("");
  const [PeriodFrom, setPeriodFrom] = useState(null);
  const [PeriodTo, setPeriodTo] = useState(null);
  const [newOS, setNewOS] = useState("");
  const [responseEntity, getResponseEntity] = useState([]);
  const [entity, setEntity] = useState(null);
  const [documentTitle, setDocumentTitle] = useState("");
  const [parentDocTitle, setParentDocTitle] = useState("");
  const [parentDocDescription, setParentDocDescription] = useState("");
  const [grandParentDocTitle, setGrandParentDocTitle] = useState("");
  const [grandParentDocDescription, setGrandParentDocDescription] =
    useState("");
  const [documentDescription, setDocumentDescription] = useState("");
  const [referenceDocTitle, setReferenceDocTitle] = useState("");
  const [referenceDocDescription, setReferenceDocDescription] = useState("");
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [osNo, setOsNo] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedMetadata, setSelectedMetadata] = useState(null);
  const [buildingCode, setBuildingCode] = useState([]);
  const [buildingCodeId, setBildingCodeId] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [existingFileUrl, setExistingFileUrl] = useState(null);
  const [stateList, setStateList] = useState([]);

  const [category, setCategory] = useState([]);
  const [filterType, setFilterType] = useState([]);
  const [filterSelectedCategoryId, setFilterSelectedCategoryId] = useState("");
  const [filterSelectedDocumentId, setFilterSelectedDocumentId] = useState("");
  const [filterSelectedStateId, setFilterSelectedStateId] = useState("");
  const [filterLocations, setFilterLocations] = useState([]);
  const [filterSelectedLocationId, setFilterSelectedLocationId] = useState("");
  const [filterSites, setFilterSites] = useState([]);
  const [filterSelectedSiteId, setFilterSelectedSiteId] = useState("");
  const [searchText, setSearchText] = useState("");
  const [documentId, setDocumentId] = useState("");
  const [isModalOpen, setisModalOpen] = useState(false);
  const [reciptNo, setReciptNo] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [khataName, setKhataName] = useState("");
  const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState("");
  const { instance, accounts } = useMsal();
  const [salesDeed, setSalesDeed] = useState("");
  const [sellerName, setSellerName] = useState("");
  const [selectedUniqueRaw, setSelectedUniqueRaw] = useState(null);
  const [pendingUniqueNo, setPendingUniqueNo] = useState(null);
  const [leaseDate, setLeaseDate] = useState("");
  const [leaseNumber, setLeaseNumber] = useState("");
  const [selectedSiteType, setSelectedSiteType] = useState("");
  const [cnrNumbers, setCnrNumbers] = useState([]);
  const [selectedCnrNumber, setSelectedCnrNumber] = useState("");

  const [cookies, setCookie] = useCookies([
    "email",
    "firstName",
    "lastName",
    "roleName",
    "roleId",
    "accessToken",
    "fullname",
  ]);
  // metadata when site type is others then only show litigation category if land thn show all 3 document category
  // const filteredCategory = documentCategory.filter((cat) => {
  //   if (selectedSiteType === "Others") {
  //     return cat.name === "Litigation";
  //   }
  //   return true;
  // });
const filteredCategory = documentCategory;

  // useEffect(() => {
  //   if (selectedSiteType === "Others") {
  //     const litigation = documentCategory.find(
  //       (cat) => cat.name === "Litigation",
  //     );
  //     if (litigation) {
  //       setSelectedDocumentCategory(litigation.category_id);
  //     }
  //   }
  // }, [selectedSiteType, documentCategory]);

  // metadata when site type is others then only show litigation category if land thn show all 3 document category --- end there

  // Load states on mount
  useEffect(() => {
    if (cookies.accessToken) {
      getStatesDropDown(cookies.accessToken).then((res) => {
        setStateList(res.data);
      });
    }
  }, [cookies.accessToken]);

  // documnet classification
  useEffect(() => {
    getDocumentClassificationDropDown()
      .then((res) => {
        setDocumentClassification(res.data);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  // Load states on mount
  useEffect(() => {
    getUploadAllDocumentCategory().then((res) => {
      setCategory(res.data);
    });
  }, []);

  const onFileUpload = (files) => {
    setUploadedFiles(files);
  };

  const onChangeBox = (event) => {
    setBox(event.target.value);
  };

  const handleOpen = () => {
    resetFormFields(); // ✅ Clear old state
    setOpen(true); // ✅ Open Upload modal
  };

  const handleOpenModal = () => setOpenModal(true);
  const handleClose = () => setOpen(false);

  // Utility to detect Teams context
  const isInTeams = () => {
    try {
      return window.parent !== window.self;
    } catch {
      return false;
    }
  };

  useEffect(() => {
    const fetchStates = async () => {
      try {
        let token;
        if (isInTeams()) {
          token = await new Promise((resolve, reject) => {
            microsoftTeams.authentication.getAuthToken({
              successCallback: resolve,
              failureCallback: reject,
              resources: ["https://graph.microsoft.com"],
            });
          });
        } else {
          token = await getValidAccessToken(instance, accounts);
        }
        const response = await getStatesUploadPermissionDropDown(token);
        setGetState(response.data);
        setSelectedLocationId("");
        setSelecteSiteId("");
      } catch (error) {
        console.error("Error:", error);
      }
    };
    fetchStates();
  }, []);

  useEffect(() => {
    const fetchLocationData = async () => {
      if (selectedStateId) {
        try {
          let token;
          if (isInTeams()) {
            token = await new Promise((resolve, reject) => {
              microsoftTeams.authentication.getAuthToken({
                successCallback: resolve,
                failureCallback: reject,
                resources: ["https://graph.microsoft.com"],
              });
            });
          } else {
            token = await getValidAccessToken(instance, accounts);
          }
          const response = await getLocationUploadPermissionDropDown(
            { state_id: selectedStateId },
            token,
          );
          setGetLocation(response.data);
        } catch (error) {
          console.error("Error:", error);
        }
      } else {
        setGetLocation([]);
        setSelectedLocationId("");
        setSelecteSiteId("");
      }
    };
    fetchLocationData();
  }, [selectedStateId]);

  useEffect(() => {
    const fetchSiteData = async () => {
      if (selectedLocationId) {
        try {
          let token;
          if (isInTeams()) {
            token = await new Promise((resolve, reject) => {
              microsoftTeams.authentication.getAuthToken({
                successCallback: resolve,
                failureCallback: reject,
                resources: ["https://graph.microsoft.com"],
              });
            });
          } else {
            token = await getValidAccessToken(instance, accounts);
          }
          const response = await getSiteUploadPermissionDropDown(
            { location_id: selectedLocationId },
            token,
          );
          setGetSite(response.data);
          console.log(response);
        } catch (error) {
          console.error("Error:", error);
        }
      } else {
        setGetSite([]);
        setSelecteSiteId("");
      }
    };
    fetchSiteData();
  }, [selectedLocationId]);

  // useEffect(() => {
  //   const fetchDocumentCategory = async () => {
  //     try {
  //       let token;
  //       if (isInTeams()) {
  //         token = await new Promise((resolve, reject) => {
  //           microsoftTeams.authentication.getAuthToken({
  //             successCallback: resolve,
  //             failureCallback: reject,
  //             resources: ["https://graph.microsoft.com"],
  //           });
  //         });
  //       } else {
  //         token = await getValidAccessToken(instance, accounts);
  //       }
  //       const response = await getUploadPermissionDocumentCategory(token);
  //       setDocumentCategory(response.data);

  //       setSelectedDocumentCategory("");
  //     } catch (error) {
  //       console.error("Error:", error);
  //     }
  //   };
  //   fetchDocumentCategory();
  // }, []);

  useEffect(() => {
    const fetchDocumentCategory = async () => {
      if (!selectedStateId) {
        setDocumentCategory([]);
        return;
      }

      try {
        let token = await getValidAccessToken(instance, accounts);

        const params = {
          state_id: selectedStateId,
        };

        if (selectedLocationId) {
          params.location_id = selectedLocationId;
        }

        if (selectedSiteId) {
          params.site_id = selectedSiteId;
        }

        if (cookies.role === "Location Admin" && selectedLocationId) {
          params.location_id = selectedLocationId;
        }

        // Only send location when selected
        if (selectedLocationId && selectedLocationId !== "All") {
          params.location_id = selectedLocationId;
        }

        const response = await getDocumentCategoriesByAccess(params, token);

        setDocumentCategory(response.data || []);
      } catch (error) {
        setDocumentCategory([]);
      }
    };

    fetchDocumentCategory();
  }, [selectedStateId, selectedLocationId, selectedSiteId, instance, accounts]);

  useEffect(() => {
    if (!selectedSiteId) return; // Prevent API call with undefined siteId

    getBuildingCode(selectedSiteId)
      .then((response) => {
        console.log("Building API:", response.data);
        console.log("Current selected:", buildingCodeId);
        setBuildingCode(response.data);
        console.log(response);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }, [selectedSiteId]);

  useEffect(() => {
    // setLoading(true);
    getEntity()
      .then((response) => {
        // Handle succesasful response
        getResponseEntity(response.data);
        // setLoading(false);
      })
      .catch((error) => {
        // Handle error
        // setshowModal(true);
        // setModalTitle("Something went wrong, Please try again");
        console.error("Error:", error);
        // setLoading(false);
      });
  }, []);

  useEffect(() => {
    if (selectedSiteId) {
      getUniqueNo({ site_id: selectedSiteId })
        .then((response) => {
          setUniqueNo(response.data);
          // Hydrate if editing and waiting
          if (
            pendingUniqueNo &&
            pendingUniqueNo.siteId === selectedSiteId &&
            pendingUniqueNo.value
          ) {
            const hydrated = response.data.filter((opt) =>
              Array.isArray(pendingUniqueNo.value)
                ? pendingUniqueNo.value.includes(opt.unique_survey_no)
                : opt.unique_survey_no === pendingUniqueNo.value,
            );
            setSelectedUnique(hydrated);
            setPendingUniqueNo(null); // Clear it after applying
          }
        })
        .catch((error) => {});
    } else {
      setUniqueNo([]);
    }
  }, [selectedSiteId]);




// useEffect(() => {
//   if (selectedSiteId) {
//     getCnrNumber(selectedSiteId)
//       .then((response) => {
//         console.log("CNR NUMBER API RESPONSE:", response);

//         setCnrNumbers(response.data || []);
//       })
//       .catch((error) => {
//         console.error("CNR Number API Error:", error);
//         setCnrNumbers([]);
//       });
//   } else {
//     setCnrNumbers([]);
//   }
// }, [selectedSiteId]);

useEffect(() => {
  if (selectedSiteId) {
    getCnrNumber(selectedSiteId)
      .then((response) => {
        console.log("CNR Number response:", response.data);
        setCnrNumbers(response.data || []);
      })
      .catch((error) => {
        console.error("CNR API Error:", error);
        setCnrNumbers([]);
      });
  } else {
    setCnrNumbers([]);
    setSelectedCnrNumber("");
  }
}, [selectedSiteId]);;







  useEffect(() => {
    if (selectedSiteId) {
      getOsNumber(selectedSiteId)
        .then((response) => {
          setOsNo(response.data);
          console.log(response);
        })
        .catch((error) => {
          // Handle error
          // setshowModal(true);
          // setModalTitle("Something went wrong, Please try again");
          console.error("Error:", error);
          // setLoading(false);
        });
    } else {
      setGetSite([]);
      setSelecteSiteId("");
    }
  }, [selectedSiteId]);

  // useEffect(() => {
  //   if (selectedSiteId && getSite.length > 0) {
  //     const selectedSiteObj = getSite.find(
  //       (site) => String(site.site_id) === String(selectedSiteId),
  //     );

  //     setSelectedSiteType(selectedSiteObj?.site_type || "");
  //   }
  // }, [selectedSiteId, getSite]);




useEffect(() => {
  if (
    selectedSiteId &&
    getSite.length > 0 &&
    propertyTaxData.length > 0
  ) {
    const selectedSiteObj = getSite.find(
      (site) => String(site.site_id) === String(selectedSiteId)
    );

    if (selectedSiteObj) {
      setSelectedSiteType(selectedSiteObj.site_type || "");

      const selectedPropertyTax = propertyTaxData.find(
        (item) =>
          Number(item.property_tax_applicability_id) ===
          Number(selectedSiteObj.property_tax_applicability_id)
      );

      setPropertyTax(selectedPropertyTax?.name || "");
    }
  }
}, [selectedSiteId, getSite, propertyTaxData]);


  useEffect(() => {
    if (selectedDocumentCategory && selectedSiteId) {
      getDocumentType({
        category_id: selectedDocumentCategory,
        site_id: selectedSiteId,
      })
        .then((response) => {
          setDocumentType(response.data);
          setSelectedDocumentType("");
          console.log(response);
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    } else {
      setDocumentType([]);
      setSelectedDocumentType("");
    }
  }, [selectedDocumentCategory, selectedSiteId]);

  useEffect(() => {
    getPropertyTaxApplicability()
      .then((res) => {
        console.log("Property Tax API:", res.data);
        setPropertyTaxData(res.data.property_tax_applicability || []);
      })
      .catch((err) => console.error(err));
  }, []);

  const fetchUploadedDocuments = async () => {
    try {
      let token;
      if (isInTeams()) {
        token = await new Promise((resolve, reject) => {
          microsoftTeams.authentication.getAuthToken({
            successCallback: resolve,
            failureCallback: reject,
            resources: ["https://graph.microsoft.com"],
          });
        });
      } else {
        token = await getValidAccessToken(instance, accounts);
      }
      const response = await getDocumentUploaded(token);
      setResponseData(response.data);
    } catch (error) {
      const message =
        error.response?.data?.detail || "An unexpected error occurred";
      setResponseMessage(message);
      setisModalOpen(true);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUploadedDocuments();
  }, []);

  const rowsWithActions = useMemo(() => {
    if (!responseData || responseData.length === 0) return [];

    const normalize = (str) =>
      String(str || "")
        .toLowerCase()
        .replace(/\s+/g, "");

    const normalizedSearchTerm = normalize(searchText);

    return responseData
      .filter((item) => {
        return [
          item.document_name,
          item.site_name,
          item.location_name,
          item.state_name,
          item.unique_survey_no,
          item.document_category,
          item.document_copy_type,
          item.document_type,
          item.os_number,
          item.approval_status,
          item.comments,
          item.sharepoint_id,
        ].some((field) => normalize(field).includes(normalizedSearchTerm));
      })
      .map(
        ({
          document_id,
          document_copy_type,
          document_category,
          document_type,
          building_code,
          box_number,
          other_document_description,
          area_under_litigation_acre,
          area_under_litigation_gunta,
          other_document_title,
          reference_document_title,
          reference_document_description,
          parent_document_title,
          parent_document_description,
          grand_parent_document_title,
          grand_parent_document_description,
          saledeed_no,
          seller_name,
          amount,
          khata,
          receipt_number,
          start_year,
          end_year,
          valid_until,
          url,
          site_id,
          location_id,
          state_id,
          category_id,
          document_type_id,
          document_name,
          uploaded_at,
          entity_name,
          site_name,
          location_name,
          state_name,
          unique_survey_no,
          os_number,
          approval_status,
          sharepoint_id,
          comments,
          purchase_date,
          cnr_number,
          lease_deed_date,
          lease_no,
          ...rest
        }) => {
          const date = uploaded_at ? new Date(uploaded_at) : null;
          const formattedDate = date
            ? [
                String(date.getDate()).padStart(2, "0"),
                String(date.getMonth() + 1).padStart(2, "0"),
                date.getFullYear(),
              ].join("-")
            : "";

          return {
            state_name,
            sharepoint_id,
            site_name,
            location_name,
            receipt_number,
            site_id,
            entity_name,
            location_id,
            document_category,
            document_type,
            document_copy_type,
            building_code,
            box_number,
            other_document_description,
            area_under_litigation_acre,
            area_under_litigation_gunta,
            other_document_title,
            reference_document_title,
            reference_document_description,
            parent_document_title,
            parent_document_description,
            grand_parent_document_title,
            grand_parent_document_description,
            start_year,
            end_year,
            amount,
            khata,
            saledeed_no,
            seller_name,
            valid_until,
            url,
            state_id,
            category_id,
            document_type_id,
            document_category,
            purchase_date,
            lease_deed_date,
            lease_no,
            cnr_number,
            uploaded_at: formattedDate, // dd-mm-yyyy here
            approval_status: (
              <div
                style={{
                  backgroundColor:
                    approval_status?.toLowerCase() === "rejected"
                      ? "#ffcccc"
                      : approval_status?.toLowerCase() === "pending"
                        ? "#fff3cd"
                        : "transparent",
                  padding: "4px 8px",
                  borderRadius: "4px",
                  display: "inline-block",
                }}
              >
                {approval_status}
              </div>
            ),
            comments,
            document_name: (
              <a
                href="#"
                rel="noopener noreferrer"
                style={{
                  color: "#1a0dab",
                  textDecoration: "underline",
                  wordBreak: "break-word",
                  maxWidth: "150px",
                  display: "inline-block",
                  whiteSpace: "normal",
                }}
                onClick={(e) => {
                  e.preventDefault();

                  setSelectedMetadata({
                    document_name,
                    site_name,
                    location_name,
                    state_name,
                    receipt_number,
                    site_name,
                    os_number,
                    cnr_number, 
                    document_category,
                    document_copy_type,
                    document_type,
                    building_code,
                    box_number,
                     cnr_number,
                    other_document_description,
                    other_document_title,
                    reference_document_title,
                    reference_document_description,
                    grand_parent_document_title,
                    grand_parent_document_description,
                    parent_document_title,
                    parent_document_description,
                    area_under_litigation_acre,
                    area_under_litigation_gunta,
                    start_year,
                    end_year,
                    khata,
                    amount,
                    entity_name,
                    cnr_number,
                    saledeed_no,
                    seller_name,
                    unique_survey_no: Array.isArray(unique_survey_no)
                      ? unique_survey_no.join(", ")
                      : unique_survey_no,
                    valid_until,
                    uploaded_at: formattedDate,
                    sharepoint_id,
                    url: url,
                    purchase_date,
                    lease_deed_date,
                    lease_no,
                  });
                  setModalOpen(true); // ✅ Always open the modal regardless of Teams/web
                }}
              >
                {document_name}
              </a>
            ),
            action:
              approval_status?.toLowerCase() === "rejected" ? (
                <div className="flex">
                  <img
                    src={Edit}
                    alt="Edit"
                    style={{
                      width: "20px",
                      cursor: "pointer",
                      marginRight: "10px",
                    }}
                    onClick={() => handleEdit(document_id)}
                  />
                </div>
              ) : null,
            ...rest,
          };
        },
      );
  }, [responseData, searchText]);

  const filteredRows = rowsWithActions.filter((row) => {
    const matchState = filterSelectedStateId
      ? row.state_id === filterSelectedStateId
      : true;
    const matchLocation = filterSelectedLocationId
      ? row.location_id === filterSelectedLocationId
      : true;
    const matchSite = filterSelectedSiteId
      ? row.site_id === filterSelectedSiteId
      : true;

    const matchDocumentCategory =
      filterSelectedCategoryId === 999 || !filterSelectedCategoryId
        ? true
        : row.category_id === filterSelectedCategoryId;

    const matchedDocumentType =
      filterSelectedDocumentId === 999 || !filterSelectedDocumentId
        ? true
        : row.document_type_id === filterSelectedDocumentId;

    return (
      matchState &&
      matchLocation &&
      matchSite &&
      matchDocumentCategory &&
      matchedDocumentType
    );
  });

  const handleDate = (event) => {
    setDate(event.target.value); // this will be "" if the input is cleared
  };

  const onChangeFrom = (year) => {
    if (!year || isNaN(year)) {
      setPeriodFrom(new Date().getFullYear()); // Set to current year if invalid
    } else {
      setPeriodFrom(year); // Set the selected year
    }
  };

  const onChangeTo = (year) => {
    if (!year || isNaN(year)) {
      setPeriodTo(new Date().getFullYear()); // Set to current year if invalid
    } else {
      setPeriodTo(year); // Set the selected year
    }
  };

  const handleOS = (event) => {
    setNewOS(event.target.value); // Captures text field input
  };

  const handleNewEntity = (event) => {
    const parsedValue = parseInt(event.target.value, 10);
    // If parsedValue is NaN, set to null or 0
    setEntity(isNaN(parsedValue) ? null : parsedValue);
  };

  const handleGrandParentTitle = (event) => {
    setGrandParentDocTitle(event.target.value);
  };
  const handleGrandParentDescription = (event) => {
    setGrandParentDocDescription(event.target.value);
  };
  const handleParentTitle = (event) => {
    setParentDocTitle(event.target.value);
  };

  const handleParentDescription = (event) => {
    setParentDocDescription(event.target.value);
  };

  const handleTitle = (event) => {
    setDocumentTitle(event.target.value); // Captures text field input
  };
  const handleRefTitle = (event) => {
    setReferenceDocTitle(event.target.value); // Captures text field input
  };
  const handleDescription = (event) => {
    setDocumentDescription(event.target.value); // Captures text field input
  };
  const handleRefDescription = (event) => {
    setReferenceDocDescription(event.target.value); // Captures text field input
  };
  const handleReciptNo = (event) => {
    setReciptNo(event.target.value); // Captures text field input
  };
  useEffect(() => {}, [selectedDocumentType]);

  useEffect(() => {}, [documentType]);

  // Ensure selectedDocumentType is applied only after documentType is available
  useEffect(() => {
    if (isEditing && documentType?.length > 0) {
      const docToEdit = responseData.find(
        (doc) => doc.document_id === isEditing,
      );
      if (docToEdit) {
        setSelectedDocumentType(docToEdit.document_type_id);
      }
    }
  }, [documentType, isEditing]);

  const selectedDocTypeId = selectedDocumentType; // e.g., 3
  const selectedDocTypeName = documentType?.find(
    (doc) => doc.document_type_id === selectedDocTypeId,
  )?.name;
  const selectedCategoryId = selectedDocumentCategory; // e.g., 1
  const selectedCategoryName = documentCategory?.find(
    (cat) => cat.category_id === selectedCategoryId,
  )?.name;

  const appendDataBasedOnConditions = (data, { Category, FileType }) => {
    if (Category === "Land Documents") {
      data.append("box_number", box);
      data.append("document_type", selectedDocumentType);

      if (Array.isArray(selectedUnique) && selectedUnique.length > 0) {
        selectedUnique.forEach((item) => {
          const value = item?.unique_survey_no;
          if (value && value.trim()) {
            data.append("unique_survey_no", value);
          }
        });
      }

      if (FileType === "Other Pre & Post Construction Documents") {
        data.append("document_title", documentTitle);
        data.append("document_description", documentDescription);
      }
    }
    if (FileType === "Other Land Documents") {
      data.append("other_document_title", documentTitle);
      data.append("other_document_description", documentDescription);
    }
    if (FileType === "Grand Parent Document") {
      data.append("other_document_title", grandParentDocTitle);
      data.append("other_document_description", grandParentDocDescription);
    }
    if (FileType === "Parent Document") {
      data.append("other_document_title", parentDocTitle);
      data.append("other_document_description", parentDocDescription);
    }
    if (FileType === "Reference Document") {
      data.append("other_document_title", referenceDocTitle);
      data.append("other_document_description", referenceDocDescription);
    }
    if (FileType === "Sale Deed") {
      data.append("purchase_date", date);
      data.append("saledeed_no", salesDeed);
      data.append("seller_name", sellerName);
      data.append("entity_id", parseInt(entity, 10));
    }
    if (FileType === "Lease Deed") {
      data.append("valid_until", date);
      data.append("lease_no", leaseNumber);
      data.append("lease_deed_date", leaseDate);
      data.append("entity_id", parseInt(entity, 10));
    }
    if (FileType === "Property Tax Receipt") {
      data.append("valid_until", date);
      data.append("receipt_number", reciptNo);
      if (khataName?.trim()) {
        data.append("khata", khataName);
      }
      if (date) {
        data.append("valid_until", date);
      }
      data.append("amount", amount);
    }

    if (Category === "Pre & Post Construction") {
      data.append("document_type", selectedDocumentType);

      if (Array.isArray(selectedUnique) && selectedUnique.length > 0) {
        selectedUnique.forEach((item) => {
          const value = item?.unique_survey_no;
          if (value !== undefined && value !== null && value !== "") {
            data.append("unique_survey_no", value); // ✅ Only append if truly non-empty
          }
        });
      }

      if (date) {
        data.append("valid_until", date);
      }

      data.append("box_number", box);

      if (buildingCodeId) {
        data.append("building_id", buildingCodeId); // ✅ only if present
      }

      if (FileType === "Other Pre & Post Construction Documents") {
        data.append("other_document_title", documentTitle);
        data.append("other_document_description", documentDescription);
      }
    }

    if (Category === "Litigation") {
      data.append("document_type", selectedDocumentType);
      data.append("box_number", box);
      data.append("os_number", newOS);
      if (FileType === "Other Litigation Documents") {
        data.append("other_document_title", documentTitle);
        data.append("other_document_description", documentDescription);
      }
    }
    return data;
  };

  const handleSubmit = async () => {
    const data = new FormData();

    // 1. File check
    if (uploadedFiles.length === 0) {
      setOpen(false);
      setResponseMessage("Please upload a file before submitting.");
      setIsSuccess(false);
      setisModalOpen(true);
      return;
    }

    uploadedFiles.forEach((file) => {
      data.append("file", file);
    });

    // 2. Site ID check
    const siteId = selectedSiteId ? parseInt(selectedSiteId, 10) : null;
    if (siteId === null || isNaN(siteId)) {
      setOpen(false);
      setResponseMessage("Invalid Site ID selected.");
      setIsSuccess(false);
      setisModalOpen(true);
      return;
    }

    // 3. Document Type check
    const documentId = selectedDocumentType
      ? parseInt(selectedDocumentType, 10)
      : null;
    if (documentId === null || isNaN(documentId)) {
      setOpen(false);
      setResponseMessage("Invalid Document Type selected.");
      setIsSuccess(false);
      setisModalOpen(true);
      return;
    }

    data.append("site_id", siteId);
    data.append("document_type_id", documentId);

    data.append("document_copy_type", selectedDocumentClassification);
if (selectedCnrNumber) {
  data.append("cnr_number", selectedCnrNumber);
}
    // 5. Year Period check only for specific doc types
    if (
      selectedDocTypeName === "EC" ||
      selectedDocTypeName === "Property Tax Receipt"
    ) {
      if (
        PeriodFrom !== null &&
        PeriodFrom !== "" &&
        !isNaN(PeriodFrom) &&
        PeriodTo !== null &&
        PeriodTo !== "" &&
        !isNaN(PeriodTo)
      ) {
        if (Number(PeriodFrom) < Number(PeriodTo)) {
          data.append("start_year", PeriodFrom);
          data.append("end_year", PeriodTo);
        } else {
          setOpen(false);
          setResponseMessage("Start year must be less than end year.");
          setIsSuccess(false);
          setisModalOpen(true);
          return;
        }
      } else {
        setOpen(false);
        setResponseMessage("Invalid input for start or end year.");
        setIsSuccess(false);
        setisModalOpen(true);
        return;
      }
    }

    // 7. Other conditional data
    appendDataBasedOnConditions(data, {
      Category: selectedCategoryName,
      FileType: selectedDocTypeName,
    });

    try {
      setLoading(true);
      let token;
      if (isInTeams()) {
        token = await new Promise((resolve, reject) => {
          microsoftTeams.authentication.getAuthToken({
            successCallback: resolve,
            failureCallback: reject,
            resources: ["https://graph.microsoft.com"],
          });
        });
      } else {
        token = await getValidAccessToken(instance, accounts);
      }
      // for (let pair of data.entries()) {
      //   console.log(pair[0], pair[1]);
      // }
      const response = await formUpload(data, token);
      const uploadedDoc = response.data?.uploadedDocument || response.data;

      if (uploadedDoc) {
        setResponseData((prev) => [uploadedDoc, ...prev]);
        setResponseMessage("Document uploaded successfully.");
        setIsSuccess(true);
        setisModalOpen(true);
        setOpen(false); // Close modal after success
        fetchUploadedDocuments();
        resetFormFields();
      } else {
        setOpen(false);
        setResponseMessage("Document upload returned no data.");
        setIsSuccess(false);
        setisModalOpen(true);
      }
    } catch (error) {
      console.error("Upload failed:", error);

      const details = error?.response?.data?.detail;
      if (Array.isArray(details)) {
        const combinedMessages = details.map((err) => err.msg).join(", ");
        setResponseMessage(combinedMessages);
      } else {
        setResponseMessage(
          error?.response?.data?.detail || "An error occurred during upload.",
        );
      }

      setIsSuccess(false);
      setisModalOpen(true);
      setOpen(false);
    } finally {
      setLoading(false);
    }
  };

  const resetFormFields = () => {
    setUploadedFiles([]);
    setDocumentTitle("");
    setDocumentDescription("");
    setReferenceDocTitle("");
    setReferenceDocDescription("");
    setSelectedDocumentClassification("");
    setOsNo("");
    setBox("");
    setSelecteSiteId("");
    setSelectedDocumentType("");
    setBildingCodeId("");
    setDate(""); // For Sale Deed
    setReciptNo("");
    setPeriodFrom(null);
    setPeriodTo(null);
    setEntity(null);
    setSelectedLocationId("");
    setSelectedStateId("");
    setSelectedDocumentCategory("");
    setKhataName("");
    setSalesDeed("");
    setSellerName("");
    setAmount("");
    setSelectedUnique([]);
    setLeaseDate("");
    setLeaseNumber("");
    setPropertyTax("");
    setSelectedCnrNumber("");
setCnrNumbers([]);
    setGrandParentDocTitle("");
setGrandParentDocDescription("");
setParentDocTitle("");
setParentDocDescription("");
  };

  const appendDataEdit = (data, { Category, FileType }) => {
    if (Category === "Land Documents") {
      data.append("box_number", box);
      data.append("document_type", selectedDocumentType);
      if (Array.isArray(selectedUnique) && selectedUnique.length > 0) {
        selectedUnique.forEach((item) => {
          const value = item?.unique_survey_no;
          if (value && value.trim()) {
            data.append("unique_survey_no", value);
          }
        });
      }
      if (FileType === "Other Pre & Post Construction Documents") {
        data.append("document_title", documentTitle);
        data.append("document_description", documentDescription);
      }
    }
    if (FileType === "Other Land Documents") {
      data.append("other_document_title", documentTitle);
      data.append("other_document_description", documentDescription);
    }
    if (FileType === "Grand Parent Document") {
      data.append("other_document_title", grandParentDocTitle);
      data.append("other_document_description", grandParentDocDescription);
    }
    if (FileType === "Parent Document") {
      data.append("other_document_title", parentDocTitle);
      data.append("other_document_description", parentDocDescription);
    }
    if (FileType === "Reference Document") {
      data.append("other_document_title", referenceDocTitle);
      data.append("other_document_description", referenceDocDescription);
    }
    if (FileType === "Sale Deed") {
      data.append("purchase_date", date);
      data.append("saledeed_no", salesDeed);
      data.append("seller_name", sellerName);
      data.append("entity_id", parseInt(entity, 10));
    }
    if (FileType === "Lease Deed") {
      data.append("valid_until", date);
      data.append("lease_no", leaseNumber);
      data.append("lease_deed_date", leaseDate);
      data.append("entity_id", parseInt(entity, 10));
    }
    if (FileType === "Property Tax Receipt") {
      data.append("valid_until", date);
      data.append("receipt_number", reciptNo);
      if (khataName?.trim()) {
        data.append("khata", khataName);
      }
      if (date) {
        data.append("valid_until", date);
      }
      data.append("amount", amount);
    }

    if (Category === "Pre & Post Construction") {
      data.append("document_type", selectedDocumentType);

      if (Array.isArray(selectedUnique) && selectedUnique.length > 0) {
        selectedUnique.forEach((item) => {
          const value = item?.unique_survey_no;
          if (value !== undefined && value !== null && value !== "") {
            data.append("unique_survey_no", value); // ✅ Only append if truly non-empty
          }
        });
      }

      if (date) {
        data.append("valid_until", date);
      }

      data.append("box_number", box);

      if (buildingCodeId) {
        data.append("building_id", buildingCodeId); // ✅ only if present
      }

      if (FileType === "Other Pre & Post Construction Documents") {
        data.append("other_document_title", documentTitle);
        data.append("other_document_description", documentDescription);
      }
    }

    if (Category === "Litigation") {
      data.append("document_type", selectedDocumentType);
      data.append("box_number", box);
      data.append("os_number", newOS);
      if (FileType === "Other Litigation Documents") {
        data.append("other_document_title", documentTitle);
        data.append("other_document_description", documentDescription);
      }
    }
    return data;
  };

  useEffect(() => {
    if (uniqueNo.length > 0 && selectedUniqueRaw) {
      const hydrated = Array.isArray(selectedUniqueRaw)
        ? uniqueNo.filter((opt) =>
            selectedUniqueRaw.includes(opt.unique_survey_no),
          )
        : uniqueNo.filter((opt) => opt.unique_survey_no === selectedUniqueRaw);

      setSelectedUnique(hydrated);

      setSelectedUniqueRaw(null); // Clear it after use
    }
  }, [uniqueNo, selectedUniqueRaw]);

  const handleEdit = (document_id) => {
    const docToEdit = responseData.find(
      (doc) => doc.document_id === document_id,
    );

    if (!docToEdit) return;
console.log("Edit Data:", docToEdit);
console.log("Property Tax Master:", propertyTaxData);
    setDocumentId(document_id);
    setIsEditing(document_id);
    setDocumentTitle(docToEdit.other_document_title || "");
    setReferenceDocTitle(docToEdit.reference_document_title || "");
    setSelectedStateId(docToEdit.state_id || "");
    setSelectedLocationId(docToEdit.location_id || "");
    setSelecteSiteId(docToEdit.site_id || "");
    setSelectedDocumentClassification(docToEdit.document_copy_type || "");

    setSelectedDocumentCategory(docToEdit.category_id || "");
    setSelectedDocumentType(docToEdit.document_type_id || "");
    setNewOS(docToEdit.os_number || "");
    setEntity(docToEdit.entity_id || null);
    setBox(docToEdit.box_number || "");

    setSelectedCnrNumber(docToEdit.cnr_number || "")
    setReciptNo(docToEdit.receipt_number || "");
    setDate(docToEdit.uploaded_at?.slice(0, 10) || null);
    setPeriodFrom(docToEdit.start_year || null);
    setPeriodTo(docToEdit.end_year || null);
    setBildingCodeId(docToEdit.building_id);

    setKhataName(docToEdit.khata || "");
    setAmount(docToEdit.amount || "");
    setSalesDeed(docToEdit.saledeed_no || "");
    setSellerName(docToEdit.seller_name || "");
    setDocumentDescription(docToEdit.other_document_description || "");
    setReferenceDocDescription(docToEdit.reference_document_description || "");
    setGrandParentDocDescription(
      docToEdit.grand_parent_document_description || "",
    );
    setGrandParentDocTitle(docToEdit.grand_parent_document_title || "");

    setParentDocTitle(docToEdit.parent_document_title || "");
    setParentDocDescription(docToEdit.parent_document_description || "");
    setLeaseDate(docToEdit.lease_deed_date || "");
    setLeaseNumber(docToEdit.lease_no || "");
    // Use proxy-file instead of url
    if (docToEdit.sharepoint_id) {
      setExistingFileUrl(
        `https://land-documents-dev-ejcuftebf0dzg0e8.centralindia-01.azurewebsites.net/api/proxy-file?document_id=${docToEdit.sharepoint_id}`,
      );
    } else {
      setExistingFileUrl("");
    }

    setUploadedFiles([]); // Clear current files

    // ✅ Delay hydration of unique number until uniqueNo is loaded
    setPendingUniqueNo({
      siteId: docToEdit.site_id,
      value: docToEdit.unique_survey_no,
    });
    setSelectedUniqueRaw(docToEdit.unique_survey_no);
    // ✅ This triggers fetching unique survey numbers
    setSelectedSiteType(docToEdit.site_type || "");



    setOpen(true);
  };

  const handleEditForm = async () => {
    const data = new FormData();

    if (uploadedFiles.length > 0) {
      data.append("file", uploadedFiles[0]);
    } else if (existingFileUrl) {
      data.append("existing_file_url", existingFileUrl);
    }

    const siteId = selectedSiteId ? parseInt(selectedSiteId, 10) : null;
    if (siteId === null || isNaN(siteId)) {
      setResponseMessage("Invalid site ID.");
      setIsSuccess(false);
      setisModalOpen(true);
      return;
    }

    const documentTypeId = selectedDocumentType
      ? parseInt(selectedDocumentType, 10)
      : null;
    if (documentTypeId === null || isNaN(documentTypeId)) {
      setResponseMessage("Invalid document type.");
      setIsSuccess(false);
      setisModalOpen(true);
      return;
    }

    data.append("site_id", siteId);
    data.append("document_type_id", documentTypeId);
    data.append("document_copy_type", selectedDocumentClassification);
    if (selectedCnrNumber) {
  data.append("cnr_number", selectedCnrNumber);
}
    if (
      selectedDocTypeName === "EC" ||
      selectedDocTypeName === "Property Tax Receipt"
    ) {
      if (
        PeriodFrom !== null &&
        !isNaN(PeriodFrom) &&
        PeriodTo !== null &&
        !isNaN(PeriodTo)
      ) {
        if (PeriodFrom < PeriodTo) {
          data.append("start_year", PeriodFrom);
          data.append("end_year", PeriodTo);
        } else {
          setResponseMessage("Start year must be less than end year.");
          setIsSuccess(false);
          setisModalOpen(true);
          return;
        }
      } else {
        console.error("Invalid input for start or end year.");
        setResponseMessage("Invalid input for start or end year.");
        setIsSuccess(false);
        setisModalOpen(true);
        return;
      }
    }

    appendDataEdit(data, {
      Category: selectedCategoryName,
      FileType: selectedDocTypeName,
    });

    try {
      let token;
      if (isInTeams()) {
        token = await new Promise((resolve, reject) => {
          microsoftTeams.authentication.getAuthToken({
            successCallback: resolve,
            failureCallback: reject,
            resources: ["https://graph.microsoft.com"],
          });
        });
      } else {
        token = await getValidAccessToken(instance, accounts);
      }
      const response = await reupload(documentId, data, token);

      const uploadedDoc = response.data?.uploadedDocument || response.data;
      if (uploadedDoc) {
        setResponseData((prev) => [uploadedDoc, ...prev]);
        setResponseMessage("File uploaded successfully.");
        setIsSuccess(true);
        setisModalOpen(true);
        setOpen(false);
        fetchUploadedDocuments();
      }
    } catch (error) {
      setOpen(false);
      const details = error?.response?.data?.detail;
      if (Array.isArray(details)) {
        const combinedMessages = details.map((err) => err.msg).join(", ");
        setResponseMessage(combinedMessages);
      } else {
        setResponseMessage(
          error?.response?.data?.detail || "An error occurred during upload.",
        );
      }
      setIsSuccess(false);
      setisModalOpen(true);
    }
  };

  return (
    <>
      <div>
        <TopNav />
      </div>
      <div className="px-[35px] py-2 font-bold text-2xl">File Upload</div>
      <div className="flex flex-wrap px-4 md:px-[35px] gap-2 md:gap-x-3 items-center">
        <div className="w-full sm:w-auto flex-shrink-0">
          <SearchBar
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>
        <div className="w-full sm:w-auto flex-shrink-0">
          <DropDown
            title="State"
            placeholder="None"
            responseData={stateList}
            labelKey="name"
            valueKey="state_id"
            value={filterSelectedStateId}
           onChange={async (e) => {
  const selectedState = e.target.value;

  setFilterSelectedStateId(selectedState);
  setFilterSelectedLocationId("");
  setFilterSites([]);

  let token;

  if (isInTeams()) {
    token = await new Promise((resolve, reject) => {
      microsoftTeams.authentication.getAuthToken({
        successCallback: resolve,
        failureCallback: reject,
        resources: ["https://graph.microsoft.com"],
      });
    });
  } else {
    token = await getValidAccessToken(instance, accounts);
  }

  const res = await getLocationDropDown(
    { state_id: selectedState },
    token
  );

  setFilterLocations(res.data);
}}
          />
        </div>
        <div className="w-full sm:w-auto flex-shrink-0">
          <DropDown
            title="Location"
            placeholder="None"
            responseData={filterLocations}
            labelKey="name"
            valueKey="location_id"
            value={filterSelectedLocationId}
           onChange={async (e) => {
  const selectedLocation = e.target.value;

  setFilterSelectedLocationId(selectedLocation);
  setFilterSelectedSiteId("");

  let token;

  if (isInTeams()) {
    token = await new Promise((resolve, reject) => {
      microsoftTeams.authentication.getAuthToken({
        successCallback: resolve,
        failureCallback: reject,
        resources: ["https://graph.microsoft.com"],
      });
    });
  } else {
    token = await getValidAccessToken(instance, accounts);
  }

  try {
    const res = await getSiteDropDown(
      { location_id: selectedLocation },
      token
    );

    setFilterSites(res.data);
  } catch (error) {
    console.error("Site API Error:", error);
  }
}}
          />
        </div>
        <div className="w-full sm:w-auto flex-shrink-0">
          <DropDown
            title="Site"
            placeholder="None"
            responseData={filterSites}
            labelKey="name"
            valueKey="site_id"
            value={filterSelectedSiteId}
            onChange={(e) => {
              setFilterSelectedSiteId(e.target.value);
            }}
          />
        </div>
        <div className="w-full sm:w-auto flex-shrink-0">
          <DropDown
            title="Document Category"
            placeholder="None"
            responseData={category}
            labelKey="name"
            valueKey="category_id"
            value={filterSelectedCategoryId}
            onChange={(e) => {
              const selectedCategory = e.target.value;
              setFilterSelectedCategoryId(selectedCategory);
              getAllDocumentType({ category_id: selectedCategory }).then(
                (res) => {
                  setFilterType(res.data);
                  setFilterSelectedDocumentId(null);
                },
              );
            }}
          />
        </div>
        <div className="w-full sm:w-auto flex-shrink-0">
          <DropDown
            title="Document Type"
            placeholder="None"
            responseData={filterType}
            labelKey="name"
            valueKey="document_type_id"
            value={filterSelectedDocumentId}
            onChange={(e) => {
              setFilterSelectedDocumentId(e.target.value);
            }}
          />
        </div>
        <div className="w-full sm:w-auto flex-shrink-0">
          <Button
            variant="contained"
            fullWidth
            onClick={() => {
              setFilterSelectedCategoryId(null);
              setFilterSelectedDocumentId(null);
              setFilterSelectedSiteId(null);
              setFilterSelectedLocationId(null);
              setFilterSelectedStateId(null);
              setSearchText("");
              // Clear dependent dropdown data
  setFilterLocations([]);
  setFilterSites([]);
  setFilterType([]);
            }}
            sx={{
              backgroundColor: "#1381B5",
              "&:hover": { backgroundColor: "#0f6c99" },
              width: "95px",
              height: "40px",
              fontSize: "12px",
              whiteSpace: "nowrap",
            }}
          >
            Clear All
          </Button>
        </div>

        <div className="w-full sm:w-auto py-2 sm:ml-auto flex-shrink-0">
          <NewSiteButton Name="Add File" handleOpen={handleOpen} />
          {isEditing ? (
            <EditUpload
              open={open}
              onClose={() => setOpen(false)}
              handleSubmit={handleEditForm}
              responseDataState={getState}
              responseDataLocation={getLocation}
              responseDataSite={getSite}
              nameLocation="name"
              nameState="name"
              siteName="name"
              stateId="state_id"
              locationId="location_id"
              selectedSiteID="site_id"
              responseDataClassification={documentClassification}
              selectedDocumentClassification={selectedDocumentClassification}
              onChangeDocumentClassification={(e) =>
                setSelectedDocumentClassification(e.target.value)
              }
              onChangeState={(e) => setSelectedStateId(e.target.value)}
              onChangeLocation={(e) => setSelectedLocationId(e.target.value)}
             onChangeSite={(e) => {
                const selectedId = e.target.value;
                setSelecteSiteId(selectedId);

                const selectedSiteObj = getSite.find(
                  (site) => String(site.site_id) === String(selectedId),
                );

                console.log("Selected Site:", selectedSiteObj);

                setSelectedSiteType(selectedSiteObj?.site_type || "");

                // Find the property tax name using the ID
                const selectedPropertyTax = propertyTaxData.find(
                  (item) =>
                    item.property_tax_applicability_id ===
                    selectedSiteObj?.property_tax_applicability_id,
                );


                setPropertyTax(selectedPropertyTax?.name || "");
              }}
              selectedStateId={selectedStateId}
              selectedSiteType={selectedSiteType}
              selectedLocationId={selectedLocationId}
              siteId={selectedSiteId}
              responseDataCategory={filteredCategory}
              DocumentName="name"
              selectedDocument="category_id"
              DocumentCategory={selectedDocumentCategory}
              onChangeType={(e) => setSelectedDocumentCategory(e.target.value)}
              onChangeUniqueNo={(e) => setSelectedUnique(e.target.value)}
              setSelectedUnique={setSelectedUnique}
              responseDataUniqueNo={uniqueNo}
              uniqueNoName="unique_survey_no"
              selectedUniqueId="unique_survey_no"
              uniqueNoId={selectedUnique}
              responseDataType={documentType}
              DocTypeName="name"
              selectedDocumentType="document_type_id"
              DocType={selectedDocumentType}
              onChangeDocumentType={(e) =>
                setSelectedDocumentType(e.target.value)
              }
              FileType={selectedDocTypeName}
              Category={selectedCategoryName}
              box={box}
              onChangeBox={onChangeBox}
              PurchaseDate={date}
              onChangePurchaseDate={handleDate}
              PeriodFrom={PeriodFrom}
              PeriodTo={PeriodTo}
              onChangeFrom={onChangeFrom}
              onChangeTo={onChangeTo}
              responseDataEntity={responseEntity}
              EntityNo="name"
              selectedEntity="entity_id"
              entity={entity}
              onChangeEntity={handleNewEntity}
              DocumentTitle={documentTitle}
              onChangeTitle={handleTitle}
              DocumentDescription={documentDescription}
              onChangeDescription={handleDescription}
              ReferenceDocTitle={referenceDocTitle}
              onChangeReferenceDocTitle={handleRefTitle}
              ReferenceDocDescription={referenceDocDescription}
              onChangeReferenceDocDescription={handleRefDescription}
              grandParentDocTitle={grandParentDocTitle}
              grandParentDocDescription={grandParentDocDescription}
              onChangegrandParentDocTitle={handleGrandParentTitle}
              onChangegrandParentDocDescription={handleGrandParentDescription}
              parentDocDescription={parentDocDescription}
              parentDocTitle={parentDocTitle}
              onChangeParentDocTitle={handleParentTitle}
              onChangeParentDocDescription={handleParentDescription}
              setUploadedFiles={setUploadedFiles}
              uploadedFiles={uploadedFiles}
              responseDataTypeOs={osNo}
              OsNo="os_number"
              selectedOs="os_number"
              os={newOS}
              onChangeOS={handleOS}
              responseDataBuilding={buildingCode}
              nameBuildingCode="building_name"
              buildingId="building_id"
              onChangeBuilding={(e) => setBildingCodeId(e.target.value)}
              selectedBuildingId={buildingCodeId}
              existingFileUrl={existingFileUrl}
              setExistingFileUrl={setExistingFileUrl}
              reciptTitle={reciptNo}
              onChangeReciptTitle={handleReciptNo}
              khataTitle={khataName}
              onChangeKhataTitle={(e) => setKhataName(e.target.value)}
              amountTitle={amount}
              onChangeAmountTitle={(e) => setAmount(e.target.value)}
              salesDeedNo={salesDeed}
              onChangeSalesDeedNo={(e) => setSalesDeed(e.target.value)}
              sellerName={sellerName}
              onChangeSellerName={(e) => setSellerName(e.target.value)}
              onChangeLeaseDate={(e) => setLeaseDate(e.target.value)}
              leaseDate={leaseDate}
              leaseNumber={leaseNumber}
              onChangeLeaseNumber={(e) => setLeaseNumber(e.target.value)}
              propertyTax={propertyTax}
              cnrNumbers={cnrNumbers}
selectedCnrNumber={selectedCnrNumber}
onChangeCnrNumber={(e) => setSelectedCnrNumber(e.target.value)}
            />
          ) : (
            <UploadModal
              open={open}
              onClose={() => setOpen(false)}
              handleSubmit={handleSubmit}
              responseDataState={getState}
              responseDataLocation={getLocation}
              responseDataSite={getSite}
              nameLocation="name"
              nameState="name"
              siteName="name"
              stateId="state_id"
              locationId="location_id"
              selectedSiteID="site_id"
              responseDataClassification={documentClassification}
              selectedDocumentClassification={selectedDocumentClassification}
              onChangeDocumentClassification={(e) =>
                setSelectedDocumentClassification(e.target.value)
              }
              onChangeState={(e) => setSelectedStateId(e.target.value)}
              onChangeLocation={(e) => setSelectedLocationId(e.target.value)}
              onChangeSite={(e) => {
                const selectedId = e.target.value;
                setSelecteSiteId(selectedId);

                const selectedSiteObj = getSite.find(
                  (site) => String(site.site_id) === String(selectedId),
                );

                console.log("Selected Site:", selectedSiteObj);

                setSelectedSiteType(selectedSiteObj?.site_type || "");

                // Find the property tax name using the ID
                const selectedPropertyTax = propertyTaxData.find(
                  (item) =>
                    item.property_tax_applicability_id ===
                    selectedSiteObj?.property_tax_applicability_id,
                );


                setPropertyTax(selectedPropertyTax?.name || "");
              }}
              selectedStateId={selectedStateId}
              selectedLocationId={selectedLocationId}
              siteId={selectedSiteId}
              responseDataCategory={filteredCategory}
              DocumentName="name"
              selectedDocument="category_id"
              DocumentCategory={selectedDocumentCategory}
              onChangeType={(e) => setSelectedDocumentCategory(e.target.value)}
              onChangeUniqueNo={(e) => setSelectedUnique(e.target.value)}
              setSelectedUnique={setSelectedUnique}
              responseDataUniqueNo={uniqueNo}
              uniqueNoName="unique_survey_no"
              selectedUniqueId="unique_survey_no"
              uniqueNoId={selectedUnique}
              responseDataType={documentType}
              selectedSiteType={selectedSiteType}
              DocTypeName="name"
              selectedDocumentType="document_type_id"
              DocType={selectedDocumentType}
              onChangeDocumentType={(e) =>
                setSelectedDocumentType(e.target.value)
              }
              FileType={selectedDocTypeName}
              Category={selectedCategoryName}
              box={box}
              onChangeBox={onChangeBox}
              PurchaseDate={date}
              onChangePurchaseDate={handleDate}
              PeriodFrom={PeriodFrom}
              PeriodTo={PeriodTo}
              onChangeFrom={onChangeFrom}
              onChangeTo={onChangeTo}
              responseDataEntity={responseEntity}
              EntityNo="name"
              selectedEntity="entity_id"
              entity={entity}
              onChangeEntity={handleNewEntity}
              DocumentTitle={documentTitle}
              onChangeTitle={handleTitle}
              DocumentDescription={documentDescription}
              onChangeDescription={handleDescription}
              grandParentDocTitle={grandParentDocTitle}
              grandParentDocDescription={grandParentDocDescription}
              onChangegrandParentDocTitle={handleGrandParentTitle}
              onChangegrandParentDocDescription={handleGrandParentDescription}
              // ------------------------parent doc-----------------------------
              parentDocTitle={parentDocTitle}
              parentDocDescription={parentDocDescription}
              onChangeParentDocTitle={handleParentTitle}
              onChangeParentDocDescription={handleParentDescription}
              // ----------------------------------------------
              ReferenceDocTitle={referenceDocTitle}
              onChangeReferenceDocTitle={handleRefTitle}
              ReferenceDocDescription={referenceDocDescription}
              onChangeReferenceDocDescription={handleRefDescription}
              // ---------------------------------------------------
              setUploadedFiles={setUploadedFiles}
              uploadedFiles={uploadedFiles}
              responseDataTypeOs={osNo}
              OsNo="os_number"
              selectedOs="os_number"
              os={newOS}
              onChangeOS={handleOS}
              responseDataBuilding={buildingCode}
              nameBuildingCode="building_name"
              buildingId="building_id"
              onChangeBuilding={(e) => setBildingCodeId(e.target.value)}
              selectedBuildingId={buildingCodeId}
              reciptTitle={reciptNo}
              onChangeReciptTitle={handleReciptNo}
              khataTitle={khataName}
              onChangeKhataTitle={(e) => setKhataName(e.target.value)}
              amountTitle={amount}
              onChangeAmountTitle={(e) => setAmount(e.target.value)}
              salesDeedNo={salesDeed}
              onChangeSalesDeedNo={(e) => setSalesDeed(e.target.value)}
              sellerName={sellerName}
              onChangeSellerName={(e) => setSellerName(e.target.value)}
              onChangeLeaseDate={(e) => setLeaseDate(e.target.value)}
              leaseDate={leaseDate}
              leaseNumber={leaseNumber}
              onChangeLeaseNumber={(e) => setLeaseNumber(e.target.value)}
              propertyTax={propertyTax}
               cnrNumbers={cnrNumbers}
                 selectedCnrNumber={selectedCnrNumber}
  onChangeCnrNumber={(e) => setSelectedCnrNumber(e.target.value)}
            />
          )}
        </div>
      </div>
      <div className="py-2 px-[35px]">
        <EnhancedTable
          rows={filteredRows}
          header={content.columnUpload}
          height="355px"
        />
      </div>
      <DocumentModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        metadata={selectedMetadata}
        metadataFields={[
          { key: "document_name", label: "File Name" },
          { key: "state_name", label: "State" },
          { key: "location_name", label: "Location" },
          { key: "site_name", label: "Site" },
          { key: "uploaded_at", label: "Upload Date" },
          { key: "box_number", label: "Box No" },
          { key: "unique_survey_no", label: "Survey No" },
          { key: "os_number", label: "OS Number" },
          { key: "document_category", label: "Document Category" },
          { key: "cnr_number", label: "CNR Number" },
          { key: "document_copy_type", label: "Document Classification" },
          { key: "document_type", label: "Document Type" },
          { key: "entity_name", label: "Entity" },
          { key: "building_name", label: "Building Name" },
          { key: "saledeed_no", label: "Sale Deed No" },
          { key: "seller_name", label: "Seller Name" },
          { key: "purchase_date", label: "Purchase Date" },
          { key: "lease_deed_date", label: "Lease Deed Date" },
          { key: "lease_no", label: "Lease No" },
          { key: "start_year", label: "Start Year" },
          { key: "end_year", label: "End Year" },
          { key: "valid_until", label: "Valid Until" },
          { key: "receipt_number", label: "Receipt Number" },
          { key: "khata", label: "Khata" },
          { key: "amount", label: "Amount(Rs.)" },
          { key: "other_document_title", label: "Other Document Title" },
          {
            key: "other_document_description",
            label: "Other Document Description",
          },
          {
            key: "reference_document_title",
            label: "Reference Document Title",
          },
          {
            key: "reference_document_description",
            label: "Reference Document Description",
          },
          {
            key: "grand_parent_document_title",
            label: "Grand Parent Document Title",
          },
          {
            key: "grand_parent_document_description",
            label: "Grand Parent Document Description",
          },
          { key: "parent_document_title", label: "Parent Document Title" },
          {
            key: "parent_document_description",
            label: "Parent Document Description",
          },
        ]}
      />
      ;{loading && <Spinner />}
      <StatusModal
        isOpen={isModalOpen}
        onClose={() => setisModalOpen(false)}
        message={responseMessage}
        isSuccess={isSuccess}
      />
    </>
  );
};

export default Upload;
